module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Info-circle-ab1365312e164474a3692695580e9924.svg";